import * as React from "react";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { filterClearIcon } from "@progress/kendo-svg-icons";

interface DropdownFilterCellProperties extends GridFilterCellProps {
  defaultItem: string;
  data: string[];
  onToggle?: (isFilterFocused: boolean) => void;
}

export const DropdownFilterCell = (properties: DropdownFilterCellProperties) => {
  const hasValue = (value: string) => Boolean(value && value !== properties.defaultItem);

  const onChange = (event: DropDownListChangeEvent) => {
    const isValueHasChanged = hasValue(event.target.value);
    properties.onChange({
      value: isValueHasChanged ? event.target.value : "",
      operator: isValueHasChanged ? "eq" : "",
      syntheticEvent: event.syntheticEvent,
    });
  };

  const handleFocus = () => {
    // Set the focus state to true when the dropdown gains focus
    if (properties.onToggle) properties.onToggle(true);
  };

  const handleFocusLost = () => {
    // Set the focus state to false when the dropdown loses focus
    if (properties.onToggle) properties.onToggle(false);
  };

  const onClearButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    properties.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };

  return (
    <div className="k-filtercell">
      <DropDownList
        style={{ marginRight: 5 }}
        data={properties.data}
        onChange={onChange}
        value={properties.value || properties.defaultItem}
        defaultItem={properties.defaultItem}
        onFocus={handleFocus}
        onBlur={handleFocusLost}
        onClose={handleFocusLost}
      />
      <Button title="Clear" disabled={!hasValue(properties.value)} onClick={onClearButtonClick} svgIcon={filterClearIcon} />
    </div>
  );
};
